import * as React from 'react';
import { AppBar} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import FrameworkAppContext from "./FrameworkAppContext";


const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
});

const FrameworkAppBar = (props) => {

    const appResources = React.useContext(FrameworkAppContext);
    const classes = useStyles();
    return (
        <AppBar {...props} elevation={1} >
            <Typography
                variant="h6"
                color="inherit"
                className={classes.title}
                id="react-admin-title"
            >
                {appResources ? appResources.apptitle : ''}  {appResources ? appResources.logo: ''}
            </Typography>
            <span className={classes.spacer} />
        </AppBar>
    );
};

const skipRenderIfLogOutChanged = (props, nextProps)=> {
    if(props.logout != nextProps.logout) {
        // don't re-render/update
        return true
    }
};


export default React.memo(FrameworkAppBar, skipRenderIfLogOutChanged);